export function windowIsAvailable() {
  return typeof window !== 'undefined';
}
